var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { Store, Select } from '@ngxs/store';
import { EngineState } from 'src/app/engine/state/engine.state';
import { Observable, Subject } from 'rxjs';
import { SetObjectVisibility, SetObjectPickable } from 'src/app/edit/state/edit.actions';
import { BdGraphService } from 'src/lib/graph/graph.service';
import { takeUntil } from 'rxjs/operators';
import { EngineNodesState } from 'src/app/engine/state/nodes/engine.nodes.state';
import { SetCheckedNodes, CheckInverseNodes, CheckAllNodes } from 'src/app/engine/state/nodes/engine.nodes.actions';
var CheckedNodesComponent = /** @class */ (function () {
    function CheckedNodesComponent(store, graphService, changeDetector) {
        this.store = store;
        this.graphService = graphService;
        this.changeDetector = changeDetector;
        this.leaves = [];
        this.count = 0;
        this.ngUnsubscribe = new Subject();
    }
    CheckedNodesComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.checkedNodes$
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(function (nodes) {
            _this.leaves = _this.getLeaves(nodes);
            _this.count = _this.leaves.length;
            _this.changeDetector.markForCheck();
        });
    };
    CheckedNodesComponent.prototype.ngOnDestroy = function () {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    };
    CheckedNodesComponent.prototype.getLeaves = function (nodes) {
        if (!nodes) {
            return [];
        }
        return this.graphService.getAllLeafDescendants(this.store.selectSnapshot(EngineState.getViewGraph), nodes.map(function (node) { return node.id; }));
    };
    CheckedNodesComponent.prototype.handleClearSelection = function () {
        this.store.dispatch(new SetCheckedNodes([]));
    };
    CheckedNodesComponent.prototype.handleBulkShow = function () {
        this.store.dispatch(new SetObjectVisibility(this.store.selectSnapshot(EngineNodesState.getCheckedNodes), true));
    };
    CheckedNodesComponent.prototype.handleBulkHide = function () {
        this.store.dispatch(new SetObjectVisibility(this.store.selectSnapshot(EngineNodesState.getCheckedNodes), false));
    };
    CheckedNodesComponent.prototype.handleSelectInverse = function () {
        this.store.dispatch(new CheckInverseNodes(this.store.selectSnapshot(EngineNodesState.getCheckedNodes)));
    };
    CheckedNodesComponent.prototype.handleHideInverse = function () {
        var nodes = this.getInverseSelected();
        this.store.dispatch(new SetObjectVisibility(nodes, false));
    };
    CheckedNodesComponent.prototype.handleSelectAll = function () {
        this.store.dispatch(new CheckAllNodes());
    };
    CheckedNodesComponent.prototype.handleBulkPickable = function (pickable) {
        var nodes = this.store.selectSnapshot(EngineNodesState.getCheckedNodes);
        this.store.dispatch(new SetObjectPickable(nodes, pickable));
    };
    CheckedNodesComponent.prototype.handleBulkInversePickable = function (pickable) {
        var nodes = this.getInverseSelected();
        this.store.dispatch(new SetObjectPickable(nodes, pickable));
    };
    CheckedNodesComponent.prototype.getInverseSelected = function () {
        var viewgraph = this.store.selectSnapshot(EngineState.getViewGraph);
        var nodeIds = this.store.selectSnapshot(EngineNodesState.getCheckedNodes).map(function (node) { return node.id; });
        var inverseNodeIds = this.graphService.getInverseSelection(viewgraph, nodeIds);
        return this.graphService.getNodes(viewgraph, inverseNodeIds);
    };
    __decorate([
        Select(EngineNodesState.getCheckedNodes),
        __metadata("design:type", Observable)
    ], CheckedNodesComponent.prototype, "checkedNodes$", void 0);
    return CheckedNodesComponent;
}());
export { CheckedNodesComponent };
